"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Asset", {
  enumerable: true,
  get: function get() {
    return _core.Asset;
  }
});
exports.camelCase = camelCase;
exports.delay = delay;
exports.fitImageToSize = fitImageToSize;
exports.validateAccountName = validateAccountName;

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

var _core = require("./core");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function delay(_x) {
  return _delay.apply(this, arguments);
}

function _delay() {
  _delay = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(msec) {
    var getTimeoutId,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            getTimeoutId = _args.length > 1 && _args[1] !== undefined ? _args[1] : undefined;
            _context.next = 3;
            return new Promise(function (resolve, reject) {
              var id = setTimeout(resolve, msec);
              if (getTimeoutId) getTimeoutId(id);
            });

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _delay.apply(this, arguments);
}

var snakeCaseRe = /_([a-z])/g;

function camelCase(str) {
  return str.replace(snakeCaseRe, function (_m, l) {
    return l.toUpperCase();
  });
}

function validateAccountName(value) {
  var i, label, len, suffix;
  var res = {
    error: null,
    msg: ''
  };
  suffix = "Account name should ";

  if (!value) {
    res.msg = suffix + "not be empty.";
    res.error = 'account_name_should_not_be_empty';
    return res;
  }

  var length = value.length;

  if (length < 3) {
    res.msg = suffix + "be longer.";
    res.error = 'account_name_should_be_longer';
    return res;
  }

  if (length > 16) {
    res.msg = suffix + "be shorter.";
    res.error = 'account_name_should_be_shorter';
    return res;
  }

  if (/\./.test(value)) {
    suffix = "Each account segment should ";
  }

  var ref = value.split(".");

  for (i = 0, len = ref.length; i < len; i++) {
    label = ref[i];

    if (!/^[a-z]/.test(label)) {
      res.msg = suffix + "start with a letter.";
      res.error = 'each_account_segment_should_start_with_a_letter';
      return res;
    }

    if (!/^[a-z0-9-]*$/.test(label)) {
      res.msg = suffix + "have only letters, digits, or dashes.";
      res.error = 'each_account_segment_should_have_only_letters_digits_or_dashes';
      return res;
    }

    if (/--/.test(label)) {
      res.msg = suffix + "have only one dash in a row.";
      res.error = 'each_account_segment_should_have_only_one_dash_in_a_row';
      return res;
    }

    if (!/[a-z0-9]$/.test(label)) {
      res.msg = suffix + "end with a letter or digit.";
      res.error = 'each_account_segment_should_end_with_a_letter_or_digit';
      return res;
    }

    if (!(label.length >= 3)) {
      res.msg = suffix + "be longer";
      res.error = 'each_account_segment_should_be_longer';
      return res;
    }
  }

  return res;
}

function fitImageToSize(width, height, goodWidth, goodHeight) {
  var overWidth = width / goodWidth;
  var overHeight = height / goodHeight;

  if (overWidth <= 1 && overHeight <= 1) {
    return {
      width: width,
      height: height
    };
  }

  var proportion = width / height;

  if (overWidth > overHeight) {
    width = goodWidth;
    height = Math.round(width / proportion);
  } else {
    height = goodHeight;
    width = Math.round(height * proportion);
  }

  return {
    width: width,
    height: height
  };
}